
import { Theme, createStyles, makeStyles } from '../../../../UI'

export default makeStyles((theme: Theme) =>
    createStyles({
        root: {
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            padding: '16px',
            borderRadius: '16px',
            backgroundColor: 'var(--expired-color-back)',
            border: '2px solid var(--expired-color)',
            width: '100%',
        },
        title: {
            fontSize: '16px',
            fontWeight: 'bold',
            color: 'var(--expired-color)',
            marginBottom: '16px',
        },
        emailSection: {
            padding: '16px',
            backgroundColor: '#fff',
            borderRadius: '8px',
            border: '1px solid #000',
            marginBottom: '16px',
        },
        sectionTitle: {
            fontSize: '14px',
            fontWeight: 'bold',
            color: 'var(--expired-color)',
            marginBottom: '8px',
        },
        description: {
            fontSize: '12px',
            color: '#000',
            marginBottom: '16px',
        },
        currentEmail: {
            fontSize: '12px',
            color: '#666',
            marginBottom: '16px',
            padding: '8px',
            backgroundColor: '#f5f5f5',
            borderRadius: '4px',
            border: '1px solid #ddd',
        },
        inputContainer: {
            display: 'flex',
            gap: '12px',
            alignItems: 'flex-end',
        },
        emailInput: {
            flex: 1,
        },
        sendButton: {
            minWidth: '100px',
            height: '40px',
        },
        modalContent: {
            padding: '16px 0',
        },
        modalText: {
            fontSize: '14px',
            marginBottom: '12px',
            textAlign: 'center',
        },
        modalWarning: {
            fontSize: '12px',
            color: 'var(--expired-color)',
            fontWeight: 'bold',
            textAlign: 'center',
        },
    })
)